import React from 'react'
import { Link } from 'react-router-dom'
import Icons from "../../myIcon/Icons";

export default function KitchenExperience({handleShow}) {
  return (
    <>
      <section className='kitchenexp-section'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-md-6'>
              <div className='kitchenexp-content'>
                <h5 className='heading'>See, Feel, and Experience</h5>
                <p>Discover Modular Kitchens Designed For Modern Comfort & Everyday Functionality</p>
                <ul>
                  <li>Touch & Feel Premium Materials</li>
                  <li>Explore Smart Kitchen Accessories</li>
                  <li>Meet Experienced Design Consultants</li>
                  <li>Get Personalized Space Planning</li>
                </ul>

                <Link onClick={handleShow} className="default-btn colored-btn">Visit Our Experience Center <Icons name="Longarrow_right" /></Link>
              </div>
            </div>

            <div className='col-lg-6 col-md-6'>
                <div className='kitchenexp-img'>
                    <img src='/image/kitchenexp-img.webp' alt='KitchenExperience' className='img-responsive'/>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
